import { render, staticRenderFns } from "./EditorNewComment.vue?vue&type=template&id=37864246&scoped=true&"
import script from "./EditorNewComment.vue?vue&type=script&lang=js&"
export * from "./EditorNewComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37864246",
  null
  
)

export default component.exports